import qs from 'qs'

import { ReportsApiUrl } from '../enums/reportsApiUrl'
import { getReportRequestQueryParams } from './getReportRequestQueryParams'

export const getStringFromReportQueryParams = (reportUrl: ReportsApiUrl, options?: any): string => {
  return qs.stringify(getReportRequestQueryParams(reportUrl, options))
}
